import { IconButton } from '@/atoms';
import { useGlobalMenu } from '@/contexts/menu/GlobalMenuProvider';
import { useTheme } from '@/contexts/theme';
import { cls } from '@/utils';
import { t } from 'ttag';
import styles from './LevelTitle.module.scss';

interface LevelTitleProps {
	title: string;
	onClick: () => void;
}

export const LevelTitle: React.FC<LevelTitleProps> = ({ title, onClick }) => {
	const { isMenuOpen } = useGlobalMenu();
	const themeInfo = useTheme();
	return (
		<div className={cls(styles.levelTitle, themeInfo.styles.titleColor, isMenuOpen && styles.open)}>
			<IconButton
				iconColor="--text-dark"
				iconName="arrow-left"
				onClick={onClick}
				aria-label={t`Gå tillbaka`}
				className={styles.icon}
			/>
			{title}
		</div>
	);
};
